// FilePreviewDialog — previews a local, not-yet-uploaded File (PDF or image) inline from an
// object URL, so each file of the signed-document upload draft can be checked before submitting.
// Mirrors SignedDocumentViewerDialog, but for local File objects instead of a backend content
// path — no request is made and nothing is uploaded by previewing.
import { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

export default function FilePreviewDialog ({ open, onClose, file }) {
  const { t_ } = useSmartTranslation()
  const [blobUrl, setBlobUrl] = useState('')

  useEffect(() => {
    if (!open || !file) return undefined
    const url = window.URL.createObjectURL(file)
    setBlobUrl(url)
    return () => {
      setBlobUrl('')
      window.URL.revokeObjectURL(url)
    }
  }, [open, file])

  const filename = file ? file.name : ''
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle>{filename}</DialogTitle>
      <DialogContent sx={{ height: '75vh', p: 0 }}>
        {blobUrl && (
          <iframe title={filename} src={blobUrl} style={{ width: '100%', height: '100%', border: 'none' }} />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t_('Close')}</Button>
      </DialogActions>
    </Dialog>
  )
}
